// ################################################################################################################
// PRODUCT PAGE SCROLL FUNCTIONALITY (to be refactored)
// ################################################################################################################

var classes = {
  top: 'meta--top',
  fixedTop: 'meta--fixed-top',
  middle: 'meta--middle',
  fixedBottom: 'meta--fixed-bottom',
  bottom: 'meta--bottom',
  relative: 'meta--relative'
}

var selectors = {
  header: '.site-header',
  mainContent: '.main-content',
  meta: '.product-single__meta',
  metaContainer: '.product-single__meta-container',
  productImages: '.product-single__photos'
}

var headerHeight = $(selectors.header).outerHeight();
var metaHeight = $(selectors.meta).outerHeight();
var containerHeight = $(selectors.metaContainer).outerHeight();
var upperSpacing = $(selectors.mainContent).outerHeight(true) - $(selectors.mainContent).height();
var productImagesHeight = $(selectors.productImages).outerHeight();


function resetPosition() {
  $(selectors.meta).removeClass(classes.top);
  $(selectors.meta).removeClass(classes.fixedTop);
  $(selectors.meta).removeClass(classes.middle);
  $(selectors.meta).removeClass(classes.fixedBottom);
  $(selectors.meta).removeClass(classes.bottom);
  $(selectors.meta).removeClass(classes.relative);
  $(selectors.meta).css('top','');
}

function resetSizes() {
  $(selectors.meta).css('width', $(selectors.metaContainer).width());
  $(selectors.meta).css('height', 'auto');
  headerHeight = $(selectors.header).outerHeight();
  metaHeight = $(selectors.meta).outerHeight();
  containerHeight = $(selectors.metaContainer).outerHeight();
  upperSpacing = $(selectors.mainContent).outerHeight(true) - $(selectors.mainContent).height();
  productImagesHeight = $(selectors.productImages).outerHeight();


  if (metaHeight < $(window).height()) {
    $(selectors.meta).outerHeight($(window).height());
    metaHeight = $(selectors.meta).outerHeight();
  }

  if(metaHeight >= productImagesHeight){
    resetPosition();
    $(selectors.meta).addClass(classes.relative);
  }
}

function setPosition(desiredPosition){

  resetPosition();

  switch(desiredPosition) {
      case classes.top:
          $(selectors.meta).addClass(classes.top);
          break;
      case classes.fixedTop:
          $(selectors.meta).addClass(classes.fixedTop);
          $(selectors.meta).css('top', 0);
          break;
      case classes.middle:
          // var offsetY = $(selectors.meta).offset().top;
          // console.log(offsetY);
          // $(selectors.meta).addClass(classes.middle);
          // $(selectors.meta).css('top', (offsetY - upperSpacing));
          break;
      case classes.fixedBottom:
          $(selectors.meta).addClass(classes.fixedBottom);
          break;
      case classes.bottom:
          $(selectors.meta).addClass(classes.bottom);
          break;
      default:
          break;
  }
}

function downScroll(){
  var scrollTop = $(window).scrollTop();
  var scrollBottom = $(window).scrollTop() + $(window).height();
  var offsetY = 0;

  if ($(selectors.meta).hasClass(classes.middle)){
    offsetY = $(selectors.meta).offset().top;

    if(scrollBottom >= (offsetY + metaHeight)){
      setPosition(classes.fixedBottom);
    }
  }
  else {
    if ($(selectors.meta).hasClass(classes.fixedTop)){
      offsetY = $(selectors.meta).offset().top;
      $(selectors.meta).removeClass(classes.fixedTop);
      $(selectors.meta).addClass(classes.middle);
      $(selectors.meta).css('top', (offsetY - upperSpacing));
    }
    else {
      //if meta has reached bottom, but images haven't been passed
      if((scrollBottom >= (upperSpacing + metaHeight)) & (scrollBottom < (upperSpacing + containerHeight)) ){
        setPosition(classes.fixedBottom);
      }
      //if images have been passed
      if(scrollBottom >= (upperSpacing + containerHeight)){
        setPosition(classes.bottom);
      }
    }
  }
}


function upScroll(){
  var scrollTop = $(window).scrollTop();
  var scrollBottom = $(window).scrollTop() + $(window).height();
  var offsetY = 0;

  if ($(selectors.meta).hasClass(classes.middle)){
    offsetY = $(selectors.meta).offset().top;

    if (scrollTop < offsetY){
      setPosition(classes.fixedTop);
    }
  }
  else {
    //if header hasn't been passed
    if(scrollTop < upperSpacing){
      setPosition(classes.top);
    }
    else {

      if ($(selectors.meta).hasClass(classes.fixedBottom)){
          //setPosition(classes.middle);
          offsetY = $(selectors.meta).offset().top;
          $(selectors.meta).removeClass(classes.fixedBottom);
          $(selectors.meta).addClass(classes.middle);
          $(selectors.meta).css('top', (offsetY - upperSpacing));
      }
      else {
        if (scrollTop < (containerHeight + headerHeight) && scrollTop > ((containerHeight + upperSpacing) - metaHeight)){
          setPosition(classes.bottom);
        }

        if (scrollTop < ((containerHeight + upperSpacing) - metaHeight)){
          setPosition(classes.fixedTop);
        }
      }


    }
  }

}

//change positioning of meta container on scroll
var prevScroll = 0;
var prevDirection = 'down';

$(window).on('scroll', function(){

  if($(window).width() >= 750){
    if (metaHeight < containerHeight){
      var currentScroll = $(this).scrollTop();

      if (currentScroll > prevScroll){ downScroll(); }
      else { upScroll(); }

      prevScroll = currentScroll;
    }
  }
  else{
    //if mobile, use normal scrolling
    $(selectors.meta).css('position', 'relative');
    $(selectors.meta).css('top', '0');
  }
})


//set width of meta on load
$(window).on('load', function(){

  if($(window).width() >= 750){
    //reset all sizes
    resetSizes();
  }
  else {
    //reset styles
    $(selectors.meta).removeAttr('style');
  }
})

//reset width of meta on resize
$(window).on('resize', function(){
  if($(window).width() >= 750){
    //reset all sizes
    resetSizes();
  }
  else {
    $(selectors.meta).removeAttr('style');
  }
})
